import { render, staticRenderFns } from "./DistanceConfigurationTable.vue?vue&type=template&id=079a0b74&scoped=true"
import script from "./DistanceConfigurationTable.vue?vue&type=script&lang=ts"
export * from "./DistanceConfigurationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a0b74",
  null
  
)

export default component.exports